export const bouquetImages = {
  "Mallows Bouquet (1)": "Mallows bouquet (1).jfif",
  "Mallows Bouquet (2)": "Mallows Bouquet (2).jfif",
  "Mochi Bouquet (1)": "Mochi Bouquet (1).jfif",
  "Mochi Bouquet (2)": "Mochi Bouquet (2).jfif",
  "Mochi Bouquet (3)": "Mochi Bouquet (3).jfif",
  "Mochi Bouquet (4)": "Mochi Bouquet (4).jfif",
  "Mochi Bouquet (5)": "Mochi Bouquet (5).jfif",
  "Mochi Bouquet (6)": "Mochi bouquet (6).jfif",
  "Munchkin Bouquet (1)": "Munchkin Bouquet (1).jfif",
  "Munchkin Bouquet (2)": "Munchkin bouquet (2).jfif",
  "Munchkin Bouquet (3)": "Munchkin Bouquet (3).jfif",
  "Munchkin Bouquet (4)": "Munchkin Bouquet (7).jfif",
  "Munchkin Bouquet (5)": "Munchkin Bouquet (8).jfif",
  "Munchkin Bouquet (6)": "Munchkin Bouquet (9).jfif",
  "Munchkin Bouquet (7)": "Munchkin bouquet (4).jfif",
  "Munchkin Bouquet (8)": "Munchkin Bouquet (5).jfif",
  "Munchkin Bouquet (9)": "Munchkin Bouquet (6).jfif",
  "Nala Bouquet": "Nala bouquet.jfif",
  "Nami Bouquet (1)": "Nami Bouquet (1).jfif",
  "Nami Bouquet (2)": "Nami Bouquet (2).jfif",
  "Nami Bouquet (3)": "Nami Bouquet (3).jfif",
  "Nami Bouquet (4)": "Nami Bouquet (4).jfif",
  "Nami Bouquet (5)": "Nami Bouquet (5).jfif",
  "Nami Bouquet (6)": "Nami Bouquet (6).jfif",
  "Nami Bouquet (7)": "Nami Bouquet (7).jfif",
  "Soft Thumbelina Bouquet (1)": "Soft Thumbelina Bouquet (1).jfif",
  "Soft Thumbelina Bouquet (2)": "Soft Thumbelina bouquet (2).jfif",
  "Soft Thumbelina Bouquet (3)": "Soft Thumbelina bouquet (3).jfif",
  "Soft Thumbelina Bouquet (4)": "Soft Thumbelina Bouquet (4).jfif",
  "Veto (1)": "Veto (2.jfif",
  "Veto (2)": "Veto (1).jfif",
  "Veto (3)": "Veto (3.jfif",
  "Veto (4)": "Veto (4).jfif",
  "Spring Thumbelina Bouquet (1)": "Spring Thumbelina bouquet (1).jfif",
  "Polly Bouquet (1)": "Polly Bouquet (1).jfif",
  "Matcha Bouquet (10 pcs)": "Matcha Bouquet (1).jfif",
  "Matcha Bouquet (15 pcs)": "Matcha Bouquet (1).jfif",
  "Matcha Bouquet (20 pcs)": "Matcha Bouquet (1).jfif",
  "Matcha Bouquet (25 pcs)": "Matcha Bouquet (1).jfif",
  "Matcha Bouquet (30 pcs)": "Matcha Bouquet (1).jfif",
  "Mallows Bouquet (3)": "new/Mallows Bouquet (3).jfif",
  "Mochi Bouquet (7)": "new/Mochi bouquet (7).jfif",
  "Mochi Bouquet (8)": "new/Mochi bouquet (8).jfif",
  "Nala Bouquet (2)": "new/Nala Bouquet (2).jfif",
  "Nami Bouquet (8)": "new/Nami bouquet (8).jfif",
  "Nami Bouquet (9)": "new/Nami bouquet (9).jfif",
  "Solace Bouquet (1)": "new/Solace  Bouquet (1).jfif",
  "Solace Bouquet (2)": "new/Solace  Bouquet (2).jfif",
  "Solace Bouquet (3)": "new/Solace  Bouquet (3).jfif",
  "Solace Bouquet (4)": "new/Solace  Bouquet (4).jfif",
  "Solace Bouquet (5)": "new/Solace  Bouquet (5).jfif"
};

export const bouquetPrices = {
  "Soft Thumbelina Bouquet (1)": 700,
  "Soft Thumbelina Bouquet (2)": 800,
  "Soft Thumbelina Bouquet (3)": 1300,
  "Soft Thumbelina Bouquet (4)": 1500,
  "Veto (1)": 300,
  "Veto (2)": 400,
  "Veto (3)": 600,
  "Veto (4)": 1000,
  "Munchkin Bouquet (1)": 350,
  "Munchkin Bouquet (2)": 500,
  "Munchkin Bouquet (3)": 600,
  "Munchkin Bouquet (4)": 600,
  "Munchkin Bouquet (5)": 600,
  "Munchkin Bouquet (6)": 600,
  "Munchkin Bouquet (7)": 1200,
  "Munchkin Bouquet (8)": 1500,
  "Munchkin Bouquet (9)": 1500,
  "Mallows Bouquet (1)": 500,
  "Mallows Bouquet (2)": 599,
  "Mallows Bouquet (3)": 1500,
  "Mochi Bouquet (1)": 250,
  "Mochi Bouquet (2)": 199,
  "Mochi Bouquet (3)": 500,
  "Mochi Bouquet (4)": 699,
  "Mochi Bouquet (5)": 799,
  "Mochi Bouquet (6)": 999,
  "Mochi Bouquet (7)": 1500,
  "Mochi Bouquet (8)": 1000,
  "Nala Bouquet": 999,
  "Nala Bouquet (2)": 1500,
  "Nami Bouquet (1)": 1100,
  "Nami Bouquet (2)": 1500,
  "Nami Bouquet (3)": 700,
  "Nami Bouquet (4)": 600,
  "Nami Bouquet (5)": 700,
  "Nami Bouquet (6)": 400,
  "Nami Bouquet (7)": 500,
  "Nami Bouquet (8)": 500,
  "Nami Bouquet (9)": 500,
  "Spring Thumbelina Bouquet (1)": 1200,
  "Solace Bouquet (1)": 1000,
  "Solace Bouquet (2)": 600,
  "Solace Bouquet (3)": 1000,
  "Solace Bouquet (4)": 1800,
  "Solace Bouquet (5)": 750,
  "Polly Bouquet (1)": 1500,
  "Matcha Bouquet (10 pcs)": 150,
  "Matcha Bouquet (15 pcs)": 200,
  "Matcha Bouquet (20 pcs)": 250,
  "Matcha Bouquet (25 pcs)": 300,
  "Matcha Bouquet (30 pcs)": 350,
};
